export default [
  { label: '父子', value: '1' },
  { label: '母子', value: '2' },
  { label: '父女', value: '3' },
  { label: '母女', value: '4' },
  { label: '夫妻', value: '26' },
  { label: '兄弟', value: '5' },
  { label: '兄妹', value: '6' },
  { label: '姐弟', value: '7' },
  { label: '姐妹', value: '8' },
  { label: '表兄弟', value: '9' },
  { label: '表兄妹', value: '10' },
  { label: '表姐弟', value: '11' },
  { label: '表姐妹', value: '12' },
  { label: '堂兄弟', value: '13' },
  { label: '堂兄妹', value: '14' },
  { label: '堂姐弟', value: '15' },
  { label: '堂姐妹', value: '16' },
  { label: '伯侄', value: '17' },
  { label: '叔侄', value: '18' },
  { label: '姑侄', value: '19' },
  { label: '舅甥', value: '20' },
  { label: '姨甥', value: '21' },
  { label: '公媳', value: '22' },
  { label: '婆媳', value: '23' },
  { label: '岳婿', value: '24' },
  { label: '祖孙', value: '25' },
  { label: '其他亲属关系', value: '30' },
];



// WEBPACK FOOTER //
// ./src/constants/relations-constants.js